/* ============================================================================
   susanna-kauppaehdot.js — the cart consent ticks speak Finnish when unticked
   ----------------------------------------------------------------------------
   Written 2026-09-29 (docs/open-work.md §45 item L6).

   WHAT BLOCKS CHECKOUT IS NOT THIS FILE. The ticks in
   snippets/susanna-kauppaehdot.liquid are `required` checkboxes on the native
   `cart-form`, so the browser itself refuses the submit — with or without this
   script. What the browser does NOT do is speak Finnish: its "please tick this
   box" bubble is in the browser's UI language. This file only swaps in the
   Finnish sentence from the `susanna_consent_error` theme setting (rendered
   onto each input as `data-virhe`) and shows it under the box as well, where
   it stays instead of vanishing with the bubble.

   Delegated at document level because both cart surfaces are re-rendered by
   morphing server HTML in (the drawer after every quantity change), and a
   listener bound to an input would be lost or duplicated. `invalid` does not
   bubble, so it is caught in the capture phase. If the script fails to load,
   the ticks are exactly as strict, just with the browser's own wording.
   ========================================================================= */

(() => {
  const INPUT = '.susanna-consent__input';

  /** @param {EventTarget | null} target */
  const consentInput = (target) =>
    target instanceof HTMLInputElement && target.matches(INPUT) ? target : null;

  /** @param {HTMLInputElement} input */
  const errorLine = (input) => document.getElementById(`${input.id}-virhe`);

  document.addEventListener(
    'invalid',
    (event) => {
      const input = consentInput(event.target);
      const message = input?.dataset.virhe;
      if (!input || !message) return;
      // Set inside `invalid` so the bubble the browser is about to show
      // carries it. Cleared again on `change`, or the box would stay invalid
      // even once ticked.
      if (!input.checked) input.setCustomValidity(message);
      input.setAttribute('aria-invalid', 'true');
      const line = errorLine(input);
      if (line) {
        line.textContent = message;
        line.hidden = false;
      }
    },
    true
  );

  document.addEventListener('change', (event) => {
    const input = consentInput(event.target);
    if (!input) return;
    input.setCustomValidity('');
    if (!input.checked) return;
    input.removeAttribute('aria-invalid');
    const line = errorLine(input);
    if (line) {
      line.hidden = true;
      line.textContent = '';
    }
  });
})();
